import React, { Component } from "react";
import services from "../../../services";
import $ from "jquery";
import TlkTable from "../../../components/tlelrik/table/tlkTable";
import RightPopModalForm from "../../../components/common/RightPopModalForm";
import ParcelVirsion from "../../../components/Parcel-Right-panel/ParcelVirsion";
import { MenuItemAction } from "@patternfly/react-core";

const queryString = require("query-string");
var moment = require("moment");
const dateFormat = "DD-MM-YYYY";
const fullDateFormat = "DD-MM-YYYY HH:mm:ss";
let listdefaultRequest = {
    Filters: null,
    SortBy: "",
    IsSortTypeDESC: true,
    IsPagination: true,
    Page: 1,
    PageSize: 100,
};
let today = new Date();
let current_date = moment(today).format(dateFormat);
today.setDate(today.getDate() - 7);
let LastWeek = moment(today).format(dateFormat);

today = new Date();
today.setDate(today.getDate() - 14);
let Last2Week = moment(LastWeek).format(dateFormat);

today = new Date();
today.setMonth(today.getMonth() - 1);
let Pastmonthdate = moment(today).format(dateFormat);

let tablesjson = {
    RotulosPendentes: {
        columnkeyMap: {
            entidade: "Entidade",
            correlativa: "Número de Rotulagem",
            marca: "Marca",
            seloIncorporado: "Incorporado",
            capacidade: "Capacidade",
            //capacidadeIndicada: "Capacidade",
            pais: "Mercado",
            estado: "Estado",
            dataCriado: "Data de Submissão",
        },
        actionbuttons: { Edit: "Edit" , Image: "ImageRotulos" }, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulos",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de pedidos para iniciar avaliação ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            CodEstado: 4
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosAgendaDigital: {
        columnkeyMap: {
            entidade: "Entidade",
            correlativa: "Número de Rotulagem",
            marca: "Marca",
            seloIncorporado: "Incorporado",
            capacidade: "Capacidade",
            //capacidadeIndicada: "Capacidade",
            pais: "Mercado",
            estado: "Estado",
            dataCriado: "Data de Submissão",
        },
        actionbuttons: { Edit: "Edit", Image: "ImageRotulos" }, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulos",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de pedidos para avaliação ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            IsAgendaDigital: true
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosRecurso: {
        columnkeyMap: {
            entidade: "Entidade",
            correlativa: "Número de Rotulagem",
            marca: "Marca",
            seloIncorporado: "Incorporado",
            capacidade: "Capacidade",
            //capacidadeIndicada: "Capacidade",
            pais: "Mercado",
            estado: "Estado",
            dataCriado: "Data de Submissão",
        },
        actionbuttons: { Edit: "Edit" }, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulos",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de pedidos para iniciar avaliação de recurso ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            CodEstado: 5
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosTotal: {
        columnkeyMap: {
            entidade: "Entidade",
            correlativa: "Número de Rotulagem",
            numeroRegisto: "Número de Certificação",
            marca: "Marca",
            seloIncorporado: "Incorporado",
            produto : "Produto",
            capacidade: "Capacidade",
            //capacidadeIndicada: "Capacidade",
            pais: "Mercado",
            estado: "Estado",
            historicoRecurso: "Recurso",
            dataCriado: "Data de Submissão",
            dataAvaliacao: "Última Atualização",
            mencaoQualitativa: "Menção qualitativa"
        },
        actionbuttons: { LabelEditButton1: "rotulo" , Image: "ImageRotulos"}, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulos",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de rótulos ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosTransferencias: {
        columnkeyMap: {
            numeroPedido: "Número de Pedido",
            entidade: "Entidade",
            numeroRegistoOrigem: "Número Registo Origem",
            numeroRegistoDestino: "Número Registo Destino",
            estado: "Estado",
            observacoes : "Fundamentação da decisão"
        },
        actionbuttons: { TranferenciasDetalhe: "TranferenciasDetalhe" }, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulosTransferencias",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de pedidos de transferência de rótulos ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            CodEstado: 1
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosTransferenciasTotal: {
        columnkeyMap: {
            numeroPedido: "Número de Pedido",
            entidade: "Entidade",
            numeroRegistoOrigem: "Número Registo Origem",
            numeroRegistoDestino: "Número Registo Destino",
            estado: "Estado",
            observacoes : "Fundamentação da decisão"
        },
        actionbuttons: { TranferenciasDetalhe: "TranferenciasDetalhe" }, // Redirect: "Emitir Fatura",
        listApilink: "Rotulos/ViewRotulosTransferencias",
        requestMethod: "get",
        notAction: false,
        totalPageHeading: "Lista de transferência de rótulos ",
        // deleteAPILink: "/BusEntidadeEstatuto/Delete/",
        Filters: {
            
            // typeofevaluation: "0",
            // brand: null,
            // username: null,
        },
        //groupfield: [{ field: "Estado" }],
    },
    RotulosOneAvalicao: {
        columnkeyMap: {
            "n processo": "Nº Processo",
            tipo_de_processo: "Tipo de processo",
            entidade: "Entidade",
            registo: "Registo",
            marca: "Marca",
            incorporado: "Incorporado",
            capacidade: "Capacidade",
            descrição: "Descrição",
            mercado: "Mercado",
            estado: "Estado",
            submissão: "Submissão",
            ultima_verificação: "Última verificação",
        },
        actionbuttons: { LabelEditButton1: "processOrder1" }, // Redirect: "Emitir Fatura",
        listApilink: "SIVDP/GetPendingEvaluation",
        requestMethod: "post",
        notAction: false,
        totalPageHeading: "Avaliações realizadas a aguardar ",
        modulename: "RotulosOneAvalicao",
        Filters: {
            typeofevaluation: "1",
            brand: null,
            username: null,
        },
        groupfield: [{ field: "Estado", dir: "desc" }],
    },
    RotulosTwoAvalicao: {
        columnkeyMap: {
            "n processo": "Nº Processo",
            tipo_de_processo: "Tipo de processo",
            entidade: "Entidade",
            registo: "Registo",
            marca: "Marca",
            incorporado: "Incorporado",
            capacidade: "Capacidade",
            descrição: "Descrição",
            mercado: "Mercado",
            estado: "Estado",
            submissão: "Submissão",
            ultima_verificação: "Última verificação",
        },
        actionbuttons: { LabelEditButton1: "processOrder2" }, // Redirect: "Emitir Fatura",
        listApilink: "SIVDP/GetPendingEvaluation",
        requestMethod: "post",
        notAction: false,
        totalPageHeading: "Avaliações realizadas a aguardar ",
        modulename: "RotulosTwoAvalicao",
        Filters: {
            typeofevaluation: "2",
            brand: null,
            username: null,
            // "isapproved":null,
        },
        groupfield: [{ field: "Estado" }],
    },
    ProcessosAprovados: {
        columnkeyMap: {
            "n processo": "Nº Processo",
            n_de_correlativo: "Nº de Correlativo",
            entidade: "Entidade",
            registo: "Registo",
            marca: "Marca",
            // "incorporado": "Incorporado",
            capacidade: "Capacidade",
            descrição: "Descrição",
            mercado: "Mercado",
            estado: "Estado",
            submissão: "Submissão",
            ultima_verificação: "Última verificação",
        },
        actionbuttons: { LabelDropdown: true, ImagePreview: true }, // Redirect: "Emitir Fatura",
        listApilink: "SIVDP/GetPendingEvaluation",
        requestMethod: "post",
        notAction: false,
        modulename: "ProcessosAprovados",
        Filters: {
            brand: null,
            username: null,
            isapproved: true,
        },
        groupfield: [{ field: "Estado" }],
    },
    ProcessosReprovados: {
        columnkeyMap: {
            "n processo": "Nº Processo",
            n_de_correlativo: "Nº de Correlativo",
            entidade: "Entidade",
            registo: "Registo",
            marca: "Marca",
            // "incorporado": "Incorporado",
            capacidade: "Capacidade",
            descrição: "Descrição",
            mercado: "Mercado",
            estado: "Estado",
            submissão: "Submissão",
            ultima_verificação: "Última verificação",
        },
        actionbuttons: { LabelDropdown: true, ImagePreview: true }, // Redirect: "Emitir Fatura",
        listApilink: "SIVDP/GetPendingEvaluation",
        requestMethod: "post",
        notAction: false,
        modulename: "ProcessosReprovados",
        Filters: {
            brand: null,
            username: null,
            isapproved: false,
        },
        groupfield: [{ field: "Estado" }],
    },
    minhas_avaliações: {
        columnkeyMap: {
            "n processo": "Nº Processo",
            tipo_de_processo: "Tipo de processo",
            entidade: "Entidade",
            registo: "Registo",
            marca: "Marca",
            incorporado: "Incorporado",
            capacidade: "Capacidade",
            descrição: "Descrição",
            mercado: "Mercado",
            estado: "Estado",
            submissão: "Submissão",
            ultima_verificação: "Última verificação",
        },
        actionbuttons: { LabelEditButton1: "processOrder2" }, // Redirect: "Emitir Fatura",
        listApilink: "SIVDP/GetPendingEvaluation",
        requestMethod: "post",
        notAction: false,
        totalPageHeading: "Avaliações por submeter ",
        modulename: "minhas_avaliações",
        Filters: {
            username: "1",
            isupdated: true,
        },
        groupfield: [{ field: "Estado" }],
    },
};

class RotulosTables extends Component {
    /* Primeiro passo na acomodação da classe */

    constructor(props) {
        super(props);
        this.state = {
            linkData: tablesjson[this.props.tableName],
            telkikTable: null,
            popUpForm: null,
            tlkState: null,
            error: null,
            showSearchMsg: false,
            totalcount: 0,
        };
    }

    /* Esta é a primeira etapa após o construxctor para carregar este componente  */

    componentDidMount = () => {
        // console.log("mount");
        this.defaultState();
    };

    /* Esta função irá chamar automaticamente quando o estado da página mudar  */
    componentDidUpdate = (preProp) => {
        if (
            preProp.date !== this.props.date ||
            preProp.tableName !== this.props.tableName
        ) {
            // console.log("update", this.props, preProp);
            this.defaultState();
        }
    };

    AttachmentColumn = (props) => {
        const { dataItem } = props;
  
        return (
          <td className="attachment-cell">
            <div className="attachment-wrapper">
              <img src={`data:image/png;base64,${props.anexo}`} alt="Attachment" />
              <div className="preview">
                <img src={`data:image/png;base64,${props.anexo}`} alt="Preview" />
              </div>
            </div>
          </td>
        );
    };

    /* Para obter filtros para a API */
    getAllFilter = () => {
        let Request = { ...listdefaultRequest };
        Request.Filters = this.state.linkData.Filters;
        Request.Filters = { ...Request.Filters, ...this.props.applyedfilter };
        if (
            Request.Filters.entityId === undefined ||
            Request.Filters.entityId === ""
        ) {
            Request.Filters.entityId = null;
        }
        if (
            Request.Filters.entityname === undefined ||
            Request.Filters.entityname === ""
        ) {
            Request.Filters.entityname = null;
        }

        Request = { ...Request.Filters };
        
        return Request;
    };

    /*  Para excluir uma linha da base de dados no servidor */

    handleDelete = async (id) => {
        let link = this.state.linkData.deleteAPILink;
        let res = await services.apiCall.requestApi(
            link + "/" + id,
            {},
            "post"
        );
        if (res) {
            this.defaultState();
        }
    };

    /* Carregar estado de página padrão  */

    defaultState = () => {
        let linkData = { ...tablesjson };
        linkData = tablesjson[this.props.tableName];
        this.setState(
            {
                linkData: linkData,
                tlkState: {
                    take: 20,
                    skip: 0
                },
            },
            () => this.getListData()
        );
    };

    /*Para obter dados para a tabela usando apis */

    getListData = async () => {
        //console.log("get list running 800");
        try {
            if (!this.state.linkData) return;
            let Request = this.getAllFilter();
            if (this.state.linkData.singleEntity) {
                this.setState({
                    totalcount: 0,
                    telkikTable: null,
                });
            }
            if (
                this.state.linkData.singleEntity &&
                !Request.Filters.entity_id &&
                !Request.Filters.invoice_id
            )
                return;
            let method = this.state.linkData.requestMethod;
            let link = this.state.linkData.listApilink;
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let res = {};
            res = await services.apiCall.requestApi(link, Request, method);
            // console.log("ressspnseeeee", res);
            if (res && res.length > 0) {
                res.map((_row, index) => {
                    Object.keys(columnkeyMap).map(function (key) {
                        if (key === "seloIncorporado") {
                            _row[columnkeyMap[key]] = _row.seloIncorporado ? 'Sim' :  'nd';
                        }else if(key === "historicoRecurso"){
                            _row[columnkeyMap[key]] = _row.historicoRecurso == true ? 'Sim' :  'Não';
                        }
                        // else if(key === 'estado'){
                        //     _row['Estado'] = _row.codEstado ? 'Ativo' : 'Inativo'
                        // }
                        else if (key === "estado") {
                            _row["Estado"] = _row.estado; 
                        } else if (key === "capacidadeIndicada") {
                            _row[columnkeyMap[key]] = _row.capacidadeIndicada;
                        }
                        else if (key === "mercado") {
                            _row[columnkeyMap[key]] = _row.marcadoEspecifico;
                        }
                        // else if (key === "idRegisto") {
                        //     _row[columnkeyMap[key]] = _row.codProcesso // change this key with given key in rotulo doc
                        // }
                        else if (key === "descrição") {
                            _row[columnkeyMap[key]] =
                                _row.rotulo;
                        } else if (key === "entidade") {
                            _row[columnkeyMap[key]] = _row.entidade;
                        }
                        else if (key === "dataCriado") {
                            _row[columnkeyMap[key]] = _row.dataCriado
                                ? moment(_row.dataCriado).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        }
                        else if (key === "dataAvaliacao") {
                            _row[columnkeyMap[key]] = _row.dataAvaliacao
                                ? moment(_row.dataAvaliacao).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        }
                        // else if (key === "idEntidade") {
                        //     _row[columnkeyMap[key]] = _row.nome // change this key with given key in rotulo doc
                        // }
                        else if (key === "tipo_de_processo") {
                            _row[columnkeyMap[key]] = _row.descricaos;
                        } else if (key === "n_de_correlativo") {
                            _row[columnkeyMap[key]] = _row.descricaos; 
                        }else if (key === "mencaoQualitativa") {
                            _row[columnkeyMap[key]] = _row.mencaoQualitativa;
                        } else if (key === "n processo") {
                            _row[columnkeyMap[key]] = _row.submetidoPor || "nd";
                        } else if (key === "registo") {
                            _row[columnkeyMap[key]] = _row.numeroRegisto;
                        } else if (key === "submissão") {
                            _row[columnkeyMap[key]] = _row.dataSubmissaoPedido
                                ? moment(_row.dataSubmissaoPedido).format(
                                    fullDateFormat
                                  )
                                : "nd";
                        } else if (key === "ultima_verificação") {
                            // _row[columnkeyMap[key]] = _row.dataModificado || _row.dataCriado ? moment( _row.dataModificado || _row.dataCriado ).format(fullDateFormat) : "nd";
                            _row[columnkeyMap[key]] = _row.evaluation2ReviewDate || _row.lastModifiedOn ? moment(_row.evaluation2ReviewDate || _row.lastModifiedOn).format(fullDateFormat) : "nd";
                        } else _row[columnkeyMap[key]] = _row[key] || "nd";
                    });
                });
                // console.log("Akash", "1", res);
                window.localStorage.setItem('table_total', res.length);
                this.setState(
                    {
                        data: res,
                        filterData: res,
                        showSearchMsg: false,
                        totalcount: window.localStorage.getItem("table_total"),
                    },
                    () => {
                        // console.log("Akash", "2");
                        this.createTabel();
                    }
                );
            } else {
                this.setState({
                    showSearchMsg: true,
                    totalcount: 0,
                    telkikTable: null,
                });
            }
        } catch (error) {
            this.setState({ error });
        }
    };

    /* Para carregar o componente da tabela e definir todas as colunas  */

    createTabel = () => {
        // console.log("Akash", "3");
        if (this.state.linkData && this.state.linkData.columnkeyMap) {
            let columnkeyMap = { ...this.state.linkData.columnkeyMap };
            let columnlist = Object.keys(columnkeyMap).map(function (key) {
                return { field: columnkeyMap[key], columnMenuType: "checkbox" };
            });
            let actionbuttons = this.state.linkData.actionbuttons;
            // console.log("actionbuttons", actionbuttons);
            // console.log("filterData", this.state.filterData);

            let telkikTable = (
                <TlkTable
                    pdfTitle={this.props.title}
                    date={new Date()}
                    noDownloadButton={this.state.linkData.noDownloadButton}
                    actionColumnName={this.state.linkData.actionColumnName}
                    //groupfield={this.state.linkData.groupfield}
                    modulename={this.state.linkData.modulename || "fordefault"}
                    notAction={this.state.linkData.notAction}
                    pageable={true}
                    // tlkState={this.state.tlkState}
                    deleteFunc={(id) => this.props.handleDelete(id)}
                    //tableFilters={(filter) => this.tableFilters(filter)}
                    list={this.state.filterData}
                    groupable={false}
                    actionbuttons={actionbuttons}
                    MainModule="Rotulo"
                    columnlist={columnlist}
                    ActionPerform={(action, id) =>
                        this.ActionPerform(action, id)
                    }
                />
            );
            this.setState({
                telkikTable: telkikTable,
            });
        }
    };

    /* Obter filtros aplicados na tabela para atualização dinâmica */
    tableFilters = (tlfilter) => {
        // console.log("tlfilter",tlfilter);
        try {
            let customfilters = this.getAllFilter();
            let columnkeyMap = this.state.linkData.columnkeyMap;
            let tlkState = { ...tlfilter };
            let data = this.makeTlkFilters(
                tlfilter,
                columnkeyMap,
                customfilters
            );
            let linkData = { ...this.state.linkData };

            // linkData.Filters = data.Filters
            this.setState(
                {
                    tlkState,
                    linkData,
                },
                () => this.getListData()
            );
        } catch (error) {
            this.setState({ error: error });
        }
        // return data;
    };

    /* Alterações de filtro de tabela em formatos de API */
    makeTlkFilters = (tlkfilter, columnkeyMap, data) => {
        let tlkState;
        let inFilters = {};
        let columnkeyMaprev = {};
        // console.log("-----------pppppppppp",columnkeyMap)
        for (var key in columnkeyMap) {
            columnkeyMaprev[columnkeyMap[key]] = key;
        }
        if (
            tlkfilter.filter &&
            tlkfilter.filter.filters &&
            tlkfilter.filter.filters.length > 0
        ) {
            let tkkey = "";
            let tkkeyvalues = [];
            tlkfilter.filter.filters.map((_row, i) => {
                tkkey = "";
                tkkeyvalues = [];
                let checkamount = [];
                if (_row.filters && _row.filters.length > 0) {
                    _row.filters.map((_srow, k) => {
                        tkkey = _srow.field;
                        _srow.value = _srow.value ? _srow.value : "";
                        checkamount = _srow.value;
                        if (checkamount[1] && checkamount[1] === "€") {
                            checkamount[0] = checkamount[0].replace(".", "");
                            checkamount[0] = checkamount[0].replace(",", ".");
                            _srow.value = checkamount[0];
                        }
                        _srow.value = $.isNumeric(_srow.value)
                            ? Number(_srow.value)
                            : _srow.value;
                        tkkeyvalues.push(_srow.value);
                    });
                    tkkey = columnkeyMaprev[tkkey];
                    tkkey = tkkey.toLowerCase();
                    inFilters[tkkey] = tkkeyvalues;
                }
            });
        }
        let defaultRequest = listdefaultRequest;
        defaultRequest.Page = tlkfilter.skip
            ? tlkfilter.skip / tlkfilter.take + 1
            : 1;
        defaultRequest.PageSize = tlkfilter.take ? tlkfilter.take : 100;
        if (tlkfilter && tlkfilter.sort && tlkfilter.sort.length > 0) {
            defaultRequest.SortBy = columnkeyMaprev[tlkfilter.sort[0].field];
            defaultRequest.IsSortTypeDESC =
                tlkfilter.sort[0].dir === "asc" ? false : true;
        }
        // data.inFilters = inFilters;
        return data;
    };

    /*  Para realizar a ação com base na seleção da tabela  */

    ActionPerform = (action, row) => {
        console.log("ACTION_ROW: ", row);
        if (action === "TranferenciasDetalhe") {
            console.log("row is here, ", row)
            const queryParams = queryString.stringify({
                idPedidoTransferencia: row.detalheURL,
                estado: row.estado,
                idEntidade : row.detalheURLIDEntidade
            })
            
            window.location.href = `/Detalhes_Transferencia?${queryParams}`
            // });
        }else if(action == "ImageRotulos"){
            this.AttachmentColumn(row)
        }
        else if (this.props.ActionPerform) {
            this.props.ActionPerform(action, row);
        } else {
            let popUpForm = null;
        }
        
    };
 

    /*  Para renderizar o conteúdo html da página   */

    render() {
        if (this.state.error) {
            throw this.state.error;
        }
        return (
            <div className="custom-k-grid table-section">
                <div className="table-responsive">
                    {this.state.telkikTable && (
                        <>
                            <h3>
                                {tablesjson[this.props.tableName] &&
                                tablesjson[this.props.tableName]
                                    .totalPageHeading
                                    ? tablesjson[this.props.tableName]
                                          .totalPageHeading +
                                      "(" +
                                      this.state.totalcount +
                                      ")"
                                    : `A pesquisa retornou ${this.state.totalcount} registos`}
                            </h3>
                            {this.state.telkikTable}
                        </>
                    )}
                    {this.state.totalcount == 0 && (
                        <div className="searct-found">
                            <img className="img-fluid" src="imgs/data-rotulos.png" alt="Não foram identificados registos com os critérios indicados" />
                            {this.state.showSearchMsg ? (
                                <p className="font-14">Não foram identificados registos com os critérios indicados</p>
                            ) : (
                                <h3>
                                    Pesquise uma instalação ou entidade para
                                    apresentação de mais informações
                                </h3>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export default RotulosTables;
